import { render, staticRenderFns } from "./OuterCaseManagement.vue?vue&type=template&id=101c57ae&scoped=true"
import script from "./OuterCaseManagement.vue?vue&type=script&lang=js"
export * from "./OuterCaseManagement.vue?vue&type=script&lang=js"
import style0 from "./OuterCaseManagement.vue?vue&type=style&index=0&id=101c57ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101c57ae",
  null
  
)

export default component.exports